module.exports = __webpack_public_path__ + "images/banners/item_top/item_top_banner_headline_text_d7ea7c2960eeecbb2fa43a7651b1f70d.png";